module.exports = __webpack_public_path__ + "img/teacherResource-1.fd0f075e.jpg";